// services/customerPasswordResetService.js

import API_BASE from "../config/api";

export const resetCustomerPassword = async ({
  username,
  password,
  new_password,
  confirm_password,
}) => {

  const token = localStorage.getItem("token");

  const response = await fetch(`${API_BASE}/Customer/ResetPassword`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Token": token,
    },
    body: JSON.stringify({
      username,
      password,
      new_password,
      confirm_password,
    }),
  });

  const data = await response.json();

  // ✅ check BOTH HTTP + API status
  if (!response.ok || data.status !== 0) {
    throw new Error(data?.message || "Password change failed");
  }

  return data;
};